import React from 'react';
import './Portfolio.css';

function Portfolio() {
  const projects = [
    {
      image: "/assets/images/figma.png",
      title: "E-commerce Website",
      description:
        "A fully responsive e-commerce design created in Figma with user-friendly navigation, modern aesthetics, and a clean shopping flow.",
      link: "https://dribbble.com/shots/25325936-E-commerce",
      alt: "E-commerce Design",
    },
    {
      image: "/assets/images/image-2.png",
      title: "Bluebook Renewal System",
      description:
        "A practical web system for Nepal bluebook renewal workflows with a streamlined process and clear status handling.",
      link: "https://bluebook.sudilpaudel.com.np/",
      alt: "Bluebook Renewal System",
    },
    {
      image: "/assets/images/lupiyanepal.png",
      title: "Lupiya Nepal",
      description:
        "Lupiya Nepal is a modern e-commerce platform built to support local businesses in Nepal by enabling online product browsing, cart management, and QR-based payment purchases without requiring customer login.",
      link: "https://www.lupiyanepal.com/",
      alt: "LupiyaNepal",
    },
    {
      image: "/assets/images/movie.png",
      title: "Movie App",
      description:
        "A React + Vite movie browsing app with search and favorites support. It loads movies from TMDB, lets users mark favorites, stores them in local state/localStorage, and includes routing between home and favorites pages.",
      link: "https://movie-project-6ufn.vercel.app/",
      alt: "MovieApp",
    },
  ];

  return (
    <section id="portfolio" className="portfolio-section">
      <h2 className='text-center mb-3'>My Projects</h2>
      <div className="container">
        <div className="row">
          {projects.map((project) => (
            <div key={project.title} className="col-md-4 col-sm-6">
              <div className="portfolio-item">
                <img src={project.image} alt={project.alt} />
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <a
                  href={project.link}
                  className="btn btn-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {project.link === "#" ? "Project Link Coming Soon" : "View Project"}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
